(function(){
  var ALLOW=['berizzi-spray-tips'];
  var h=(location.pathname.match(/\/products\/([^/?#]+)/)||[])[1];
  if(!h||ALLOW.indexOf(h)<0)return;
  function boot(){
    fetch('/products/'+h+'.js').then(function(r){return r.json();}).then(function(p){
      if(!p.variants||p.variants.length<40)return;
      var rows=[].slice.call(document.querySelectorAll('tr')).filter(function(tr){
        return tr.querySelector('input[type=number],input[name*=quantity]');});
      if(rows.length<40)return;
      var mapped=0;
      rows.forEach(function(tr){
        var txt=tr.innerText.replace(/\s+/g,' ').trim();
        for(var i=0;i<p.variants.length;i++){var v=p.variants[i];
          if(txt.indexOf(v.title)===0||txt.indexOf(v.title)>-1){
            tr.setAttribute('data-o1',v.option1||'');tr.setAttribute('data-o2',v.option2||'');
            tr.setAttribute('data-o3',v.option3||'');mapped++;break;}}});
      if(!mapped)return;
      var tbl=rows[0].closest('table'); if(!tbl)return;
      var box=document.createElement('div');
      box.className='st-vfilter';
      box.setAttribute('style','position:sticky;top:0;z-index:50;background:#fff;border:2px solid #111;border-radius:6px;padding:.75rem;margin:.75rem 0;display:flex;gap:.75rem;flex-wrap:wrap;align-items:flex-end;font-size:14px');
      function sel(label,vals,key){
        var w=document.createElement('label');
        w.setAttribute('style','display:flex;flex-direction:column;gap:.25rem;font-weight:600;flex:1 1 160px;min-width:140px');
        var sp=document.createElement('span');sp.textContent=label;w.appendChild(sp);
        var s=document.createElement('select');
        s.setAttribute('style','padding:.55rem;font-size:16px;border:1px solid #999;border-radius:4px;width:100%');
        s.setAttribute('data-key',key);
        var o=document.createElement('option');o.value='';o.textContent='All ('+vals.length+')';s.appendChild(o);
        vals.forEach(function(v){var x=document.createElement('option');x.value=v;x.textContent=v;s.appendChild(x);});
        w.appendChild(s);return w;}
      p.options.forEach(function(op,i){ if(op.values.length>1) box.appendChild(sel(op.name,op.values,'o'+(i+1))); });
      var qw=document.createElement('label');
      qw.setAttribute('style','display:flex;flex-direction:column;gap:.25rem;font-weight:600;flex:1 1 180px');
      var qs=document.createElement('span');qs.textContent='Search SKU / name';qw.appendChild(qs);
      var qi=document.createElement('input');qi.type='search';
      qi.setAttribute('style','padding:.55rem;font-size:16px;border:1px solid #999;border-radius:4px;width:100%');
      qw.appendChild(qi);box.appendChild(qw);
      var cnt=document.createElement('div');
      cnt.setAttribute('style','font-weight:700;white-space:nowrap;padding-bottom:.6rem');
      box.appendChild(cnt);
      var clr=document.createElement('button');clr.type='button';clr.textContent='Clear';
      clr.setAttribute('style','padding:.55rem .9rem;font-size:15px;border:1px solid #111;background:#f2f2f2;border-radius:4px;cursor:pointer');
      box.appendChild(clr);
      tbl.parentNode.insertBefore(box,tbl);
      function apply(){
        var sels=[].slice.call(box.querySelectorAll('select'));
        var q=(qi.value||'').toLowerCase().trim();
        var shown=0;
        rows.forEach(function(tr){
          var ok=true;
          sels.forEach(function(s){ if(s.value&&tr.getAttribute('data-'+s.getAttribute('data-key'))!==s.value) ok=false; });
          if(ok&&q&&tr.innerText.toLowerCase().indexOf(q)<0) ok=false;
          tr.style.display=ok?'':'none'; if(ok)shown++;});
        cnt.textContent=shown+' of '+rows.length+' shown';}
      box.addEventListener('change',apply);
      qi.addEventListener('input',apply);
      clr.addEventListener('click',function(){
        [].slice.call(box.querySelectorAll('select')).forEach(function(s){s.value='';});
        qi.value='';apply();});
      apply();
    }).catch(function(){});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(boot,1200);});
  else setTimeout(boot,1200);
})();